export default __webpack_public_path__ + "static/media/call-me-icon.f53300be.svg";